import { Component, ViewEncapsulation } from '@angular/core';
import { StartupService } from '@public/src/application/services/startup.service';
import { LocationSelectorService } from '@services/location_selector.service';
import { sharedResolution } from '../../../../src/shared_resolution';
import { SpaContext } from '../../Classes/spacontext';
import { UnitService } from '../../Services/api/v2/Units/units.service';
import { WebContentButtonsService } from '../../Services/api/v2/Units/webContentButtons.service';
import { AuthContextService } from '../../Services/authContext.service';
import { FlexiblePatientButtonsService } from '../../Services/flexible_patient_buttons.service/mod';
import { ScheduledDataService } from '../../Services/scheduled-data';
import { SpaEventService } from '../../Services/spaEvents.service';

@Component({
	standalone: false,
	templateUrl: '../../ViewHtml/Index/IndexMain.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['../../Css/Views/Index/IndexMain.scss'],
})
export class IndexComponent {
	title: string = '';
	body: string = '';
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	unit: any;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	selectValues: Array<any>;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	model: any = { Phone: '3' };
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	theme: any;
	myCasesNotificationCount = 0;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	doors: Array<any> = [];
	public extraHeaderHeight: boolean = false;
	private _subscribers = [];

	constructor(
		public readonly flexiblePatientButtonsService: FlexiblePatientButtonsService,
		public spaContext: SpaContext,
		public authContextService: AuthContextService,
		private _unitController: UnitService,
		private _spaEventService: SpaEventService,
		private _scheduledDataService: ScheduledDataService,
		public webContentButtonsService: WebContentButtonsService,
		public startupService: StartupService,
	) {
		this.unit = spaContext.unitConfig.Unit;
		this.theme = spaContext.unitConfig.Theme;
		if (__visiba_feature_flags__['PatientWeb.NHS.Navigation']) {
			this.extraHeaderHeight = startupService.nhsInfo.isInNHSApp;
		}
	}

	ngOnInit() {
		this.flexiblePatientButtonsService.fetchComponents();

		this._unitController.getText(['View_Index_Title', 'View_Index_Body']).subscribe(
			(response) => {
				this.title = response.data.View_Index_Title;
				this.body = response.data.View_Index_Body;
			},
			(err) => {
				console.log(err);
			},
		);

		const subscriber1 = this._scheduledDataService.onGetCases.subscribe((caseList) => {
			const issues = caseList.map((c) => c.UnhandledIssues.length).reduce((a, b) => a + b, 0);
			this.myCasesNotificationCount = issues;
		});
		this._subscribers.push(subscriber1);
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	isInstanceOf(a: any, b: any) {
		return a instanceof b;
	}

	ngOnDestroy() {
		this._subscribers.forEach((s) => s.unsubscribe());
	}

	signIn() {
		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);
		this._spaEventService.onSignInRequired.emit({
			leave: false,
			target: '/' + locationSelectorService.location.route,
			reason: null,
		});
	}
}
